import { gql } from "urql"

export default gql`
  mutation ($sourceUserId: ID!, $matchUserId: ID!) {
    unmatchUser(tutorId: $sourceUserId, studentId: $matchUserId) {
      student {
        id
      }
    }
  }
`
